import { render, staticRenderFns } from "./agam_ReleasePage.vue?vue&type=template&id=6561358c&"
import script from "./agam_ReleasePage.vue?vue&type=script&lang=js&"
export * from "./agam_ReleasePage.vue?vue&type=script&lang=js&"
import style0 from "./agam_ReleasePage.vue?vue&type=style&index=0&id=6561358c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports